import React from "react";
import { Alert, Spinner } from "@amzn/awsui-components-react";
import { IPermissionBoundaryProps } from "./definitions";
import { useGuestPermissions } from "hooks/useGuestPermissions";

const PermissionBoundary: React.FC<IPermissionBoundaryProps> = (
  props: IPermissionBoundaryProps,
) => {
  const {
    children,
    shouldCheckPermission = true,
    allowMemberOnly = true,
    fallbackMessage,
    fallbackHeader,
  } = props;

  // Do not allow guest to access any Gaia web app pages unless we explicitly to allow
  const { isGuest, teamName } = useGuestPermissions();

  if (!teamName) {
    return <div />;
  }

  if (allowMemberOnly) {
    if (isGuest) {
      return (
        <Alert type="warning" header={fallbackHeader || "Access Restricted"}>
          {fallbackMessage || "You are not authorized to access this page."}
        </Alert>
      );
    }

    return <>{children}</>;
  }

  // handle page which requires coral data loading from backend
  if (shouldCheckPermission) {
    const { isLoading, isError, error } = props;

    const header = fallbackHeader || "Access Restricted";
    const message =
      fallbackMessage || "You are not authorized to access this resource.";

    if (isLoading) {
      return <Spinner />;
    }

    if (
      isError &&
      (error?.status === 403 ||
        (error?.status === 400 &&
          error.data.__type ===
            "com.amazon.gaiaauditmanagementservice.exceptions#ForbiddenException"))
    ) {
      return (
        <Alert type="warning" header={header}>
          {message}
        </Alert>
      );
    }

    return <>{children}</>;
  }

  // this expects children to handle the permission
  return <>{children}</>;
};

export default PermissionBoundary;
